import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export function initGallery() {
    Fancybox.bind("[data-fancybox='gallery']", {});
}